export interface TimezoneOption {
  id: string; // IANA timezone id, e.g. 'Europe/London' — DST-correct
  name: string;
}

// Shared list of common timezones. The IANA `id` is the stored value everywhere
// (reminder config, desk booking window) — it stays correct across DST transitions.
export const TIMEZONES: TimezoneOption[] = [
  { id: 'Pacific/Midway', name: '(UTC-11:00) Midway Island' },
  { id: 'Pacific/Honolulu', name: '(UTC-10:00) Hawaii' },
  { id: 'America/Anchorage', name: '(UTC-09:00) Alaska' },
  { id: 'America/Los_Angeles', name: '(UTC-08:00) Pacific Time (US & Canada)' },
  { id: 'America/Denver', name: '(UTC-07:00) Mountain Time (US & Canada)' },
  { id: 'America/Chicago', name: '(UTC-06:00) Central Time (US & Canada)' },
  { id: 'America/New_York', name: '(UTC-05:00) Eastern Time (US & Canada)' },
  { id: 'America/Halifax', name: '(UTC-04:00) Atlantic Time (Canada)' },
  { id: 'America/St_Johns', name: '(UTC-03:30) Newfoundland' },
  { id: 'America/Sao_Paulo', name: '(UTC-03:00) Brasilia' },
  { id: 'UTC', name: '(UTC+00:00) Coordinated Universal Time' },
  { id: 'Europe/London', name: '(UTC+00:00) Dublin, Edinburgh, Lisbon, London' },
  { id: 'Europe/Berlin', name: '(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna' },
  { id: 'Africa/Lagos', name: '(UTC+01:00) West Central Africa' },
  { id: 'Europe/Athens', name: '(UTC+02:00) Athens, Bucharest' },
  { id: 'Africa/Cairo', name: '(UTC+02:00) Cairo' },
  { id: 'Europe/Moscow', name: '(UTC+03:00) Moscow, St. Petersburg' },
  { id: 'Asia/Dubai', name: '(UTC+04:00) Abu Dhabi, Muscat' },
  { id: 'Asia/Kabul', name: '(UTC+04:30) Kabul' },
  { id: 'Asia/Karachi', name: '(UTC+05:00) Islamabad, Karachi' },
  { id: 'Asia/Kolkata', name: '(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi' },
  { id: 'Asia/Kathmandu', name: '(UTC+05:45) Kathmandu' },
  { id: 'Asia/Dhaka', name: '(UTC+06:00) Astana, Dhaka' },
  { id: 'Asia/Bangkok', name: '(UTC+07:00) Bangkok, Hanoi, Jakarta' },
  { id: 'Asia/Shanghai', name: '(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi' },
  { id: 'Asia/Singapore', name: '(UTC+08:00) Kuala Lumpur, Singapore' },
  { id: 'Asia/Tokyo', name: '(UTC+09:00) Osaka, Sapporo, Tokyo' },
  { id: 'Australia/Adelaide', name: '(UTC+09:30) Adelaide' },
  { id: 'Australia/Sydney', name: '(UTC+10:00) Canberra, Melbourne, Sydney' },
  { id: 'Asia/Vladivostok', name: '(UTC+10:00) Vladivostok' },
  { id: 'Pacific/Guadalcanal', name: '(UTC+11:00) Solomon Is., New Caledonia' },
  { id: 'Pacific/Auckland', name: '(UTC+12:00) Auckland, Wellington' },
  { id: 'Pacific/Fiji', name: '(UTC+12:00) Fiji' },
  { id: 'Pacific/Tongatapu', name: '(UTC+13:00) Nuku\'alofa' }
];
